import Model from './model'

export default class VehicleYear extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/vehicle-year'
    }
}
